import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRuleDetail } from '~/modules';
import { RouteId } from '~/routes/RouteId';

export interface RuleDetailDialogControls {
  isOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

export const useRuleDetailDialogControls = (): RuleDetailDialogControls => {
  const [isOpen, setOpenRuleDetailDialog] = useState(false);
  const { ruleId } = useRuleDetail();
  // TODO: retrieve the data through a query if ruleId undefined

  const navigate = useNavigate();
  const closeDialog = useCallback(
    () => (ruleId ? setOpenRuleDetailDialog(false) : navigate(RouteId.ruleList)),
    [ruleId, navigate],
  );

  return {
    isOpen,
    openDialog: () => setOpenRuleDetailDialog(true),
    closeDialog,
  };
};
